import React from 'react';
import {Col, ProgressBar, Row} from "react-bootstrap";
import './LoadingRow.css'

export const LoadingRow = () => (<Row className="page-loading"><Col xs={{span: 10, offset: 1}}><ProgressBar animated now={100} /></Col></Row>);